export default "<h1 class=\"page-title\">Other</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";